package com.bulut.mecitogullari.ui.screens.reports

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.bulut.mecitogullari.core.util.YearMonth
import com.bulut.mecitogullari.core.util.currentYearMonth
import com.bulut.mecitogullari.data.model.MonthSummary
import com.bulut.mecitogullari.data.model.TransactionType
import com.bulut.mecitogullari.data.model.categoryBreakdown
import com.bulut.mecitogullari.data.model.computeMonthSummary
import com.bulut.mecitogullari.data.model.ledgerOnly
import com.bulut.mecitogullari.data.model.inMonth
import com.bulut.mecitogullari.data.repository.NotesRepository
import com.bulut.mecitogullari.data.repository.TransactionRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class ReportsUiState(
    val month: YearMonth = currentYearMonth(),
    val summary: MonthSummary = MonthSummary(currentYearMonth()),
    val expenseBreakdown: List<Pair<String, Double>> = emptyList(),
    val incomeBreakdown: List<Pair<String, Double>> = emptyList(),
    val savedNote: String = "",
)

class ReportsViewModel(
    transactionRepository: TransactionRepository,
    private val notesRepository: NotesRepository,
) : ViewModel() {

    private val selectedMonth = MutableStateFlow(currentYearMonth())

    val uiState: StateFlow<ReportsUiState> = combine(
        transactionRepository.transactions,
        notesRepository.notes,
        selectedMonth,
    ) { transactions, notes, month ->
        val monthTransactions = transactions.ledgerOnly().inMonth(month)
        ReportsUiState(
            month = month,
            summary = computeMonthSummary(transactions, month),
            expenseBreakdown = monthTransactions.categoryBreakdown(TransactionType.EXPENSE),
            incomeBreakdown = monthTransactions.categoryBreakdown(TransactionType.INCOME),
            savedNote = notes["${month.year}-${month.month}"] ?: "",
        )
    }.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5_000),
        initialValue = ReportsUiState(),
    )

    fun onPreviousMonth() = selectedMonth.update { it.previous() }

    fun onNextMonth() = selectedMonth.update { it.next() }

    fun saveNote(text: String) {
        viewModelScope.launch {
            notesRepository.setNote(selectedMonth.value, text)
        }
    }
}
